var _path, _polygon, _line, _line2, _line3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClickappLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 260 120 A 100 100 0 1 0 260 280",
    fill: "none",
    stroke: "#0b2a5b",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "210,210 300,250 240,300",
    fill: "#2f6df6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 200,
    x2: 275,
    y2: 180,
    stroke: "#2f6df6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 275,
    y1: 210,
    x2: 300,
    y2: 200,
    stroke: "#2f6df6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 255,
    y1: 215,
    x2: 255,
    y2: 185,
    stroke: "#2f6df6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 350,
    fill: "#0b2a5b",
    style: {
      fontSize: 40,
      fontFamily: "Arial",
      fontWeight: "bold",
      textAnchor: "middle"
    }
  }, "click app"));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickappLogo);
export default __webpack_public_path__ + "static/media/clickapp-logo.035352c90d01050c5381d89245dbc27d.svg";
export { ForwardRef as ReactComponent };